var _rect, _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F6F3FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.6667,
    cy: 15.3346,
    r: 2.66667,
    fill: "#7E59EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 17.332H11.3333V23.9987C11.3333 24.7351 10.7364 25.332 10 25.332H9.33333C8.59695 25.332 8 24.7351 8 23.9987V17.332Z",
    fill: "#A78DEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 17.344V13.3253C6 11.6286 7.37544 10.2531 9.07213 10.2531C12.1109 10.2531 15.1254 9.71212 17.9745 8.65545L21.9856 7.16781C22.6388 6.92556 23.3333 7.40874 23.3333 8.10541V22.5639C23.3333 23.2605 22.6388 23.7437 21.9856 23.5015L17.9745 22.0138C15.1254 20.9572 12.1109 20.4162 9.07213 20.4162C7.37544 20.4162 6 19.0407 6 17.344Z",
    fill: "#A78DEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3333 10.043V20.6231C11.2538 20.4845 10.1645 20.4146 9.07213 20.4146C7.37544 20.4146 6 19.0391 6 17.3424V13.3237C6 11.627 7.37544 10.2515 9.07213 10.2515C10.1645 10.2515 11.2538 10.1816 12.3333 10.043Z",
    fill: "#7E59EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotice);
export default __webpack_public_path__ + "static/media/notice.d807efc6e5a54d3d1ab07326a898da3b.svg";
export { ForwardRef as ReactComponent };